<template>
  <el-table :data="smplForm.smpl_plmtrl_list" border class="el-table-two" @selection-change="handleSelectionChange2">
    <el-table-column type="expand">
      <template v-slot="scope">
        <sub-table :tableData="scope.row.childList"></sub-table>
      </template>
    </el-table-column>
    <el-table-column align="center" type="selection" width="48"></el-table-column>
    <el-table-column align="center" label="序号" width="60">
      <template v-slot="scope">
        {{ scope.$index + 1 }}
      </template>
    </el-table-column>
    <el-table-column>
      <template slot="header">
        <span class="vg_deep_red">物料类型</span>
      </template>
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.smpl_mtrl_type'" :rules="[{ required: true }]" label-width="0">
          <el-select
            v-model="smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_type"
            filterable
            placeholder="请选择物料类型"
            size="small"
            @change="val => changePlmtrlOption(val, scope.$index)"
          >
            <el-option
              v-for="item in [
                { label: '原面料', id: 0 },
                { label: '辅料', id: 1 }
              ]"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column>
      <template slot="header">
        <span class="vg_deep_red">所用物料</span>
      </template>
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.smpl_parent_ids'" :rules="[{ required: true }]" label-width="0">
          <div class="vd_dis">
            <el-tag
              v-for="tag in smplForm.smpl_plmtrl_list[scope.$index].smpl_parent_listO"
              :key="tag.key"
              :closable="!isShow"
              class="vd_magr3"
              type="success"
              @close="handleClose(scope, tag)"
            >
              {{ tag.mtrl_no }}
            </el-tag>
            <el-popover :disabled="isShow" placement="bottom" trigger="click" width="300">
              <!--<el-tag-->
              <!--  v-for="tag in selectPlmtrlOption"-->
              <!--  :key="tag.smpl_mtrl_id"-->
              <!--  class="vg_cursor vd_magr3"-->
              <!--  type="info"-->
              <!--  @click="plmtrlChange(scope, tag)"-->
              <!--&gt;-->
              <!--  {{ tag.mtrl_no }}({{ tag.mtrl_name }})-->
              <!--</el-tag>-->
              <el-button :disabled="isShow" plian type="success" @click="plmtrlChange(scope)">确认</el-button>
              <el-select ref="multiSelect" v-model="multipleModel" filterable multiple size="small" value-key="mtrl_no" @change="onChange">
                <el-option
                  v-for="item in selectPlmtrlOption"
                  :key="item.mtrl_no + '(' + item.mtrl_name + ')'"
                  :label="item.mtrl_no + '(' + item.mtrl_name + ')'"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-button
                slot="reference"
                :disabled="isShow"
                class="el-icon-plus vg_pointer vd_clire"
                plian
                @click="addDefaultList(scope.$index)"
              ></el-button>
              <!-- <el-button icon="el-icon-plus vd_clire" plian></el-button> -->
            </el-popover>
          </div>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column>
      <template slot="header">
        <span class="vg_deep_red">加工类型</span>
      </template>
      <template v-slot="scope">
        <div style="text-align: center">
          <el-link :disabled="isShow" class="vg_cursor vg_mr_8" type="primary" @click="compListChange(scope, 0)">F</el-link>
          <el-link :disabled="isShow" class="vg_cursor vg_mr_8" type="primary"></el-link>
          <el-link :disabled="isShow" class="vg_cursor vg_mr_8" type="primary"></el-link>
          <el-link :disabled="isShow" class="vg_cursor vg_mr_8" type="primary" @click="compListChange(scope, 1)">Y</el-link>
          <!--        <el-link @click="compListChange(scope, 2)" :disabled="isShow" type="primary" class="vg_cursor">电绣</el-link>-->
        </div>
      </template>
    </el-table-column>
    <el-table-column width="200px">
      <template slot="header">
        <span class="vg_deep_red">物料编号</span>
      </template>
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.mtrl_no'" :rules="[{ required: true }]" label-width="0">
          <el-input
            v-model="smplForm.smpl_plmtrl_list[scope.$index].mtrl_no"
            maxlength="100"
            placeholder="暂无物料编号"
            show-word-limit
            @change="plmtrlChangeCut(scope)"
            @input="smplForm.smpl_plmtrl_list[scope.$index].mtrl_no = helper.keepEngNum2(smplForm.smpl_plmtrl_list[scope.$index].mtrl_no)"
          ></el-input>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column label="物料名称" width="200">
      <template slot="header">
        <span class="vg_deep_red">物料名称</span>
      </template>
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.mtrl_name'" :rules="[{ required: true }]" label-width="0">
          <el-tooltip :content="smplForm.smpl_plmtrl_list[scope.$index].mtrl_name" class="item" effect="dark" placement="top">
            <el-input
              v-model="smplForm.smpl_plmtrl_list[scope.$index].mtrl_name"
              clearable
              maxlength="100"
              placeholder="暂无物料名称"
              show-word-limit
            ></el-input>
          </el-tooltip>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column label="物料单位" width="80">
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.mtrl_unit'" label-width="1000">
          <!-- <el-select v-model="smplForm.smpl_plmtrl_list[scope.$index].mtrl_unit" placeholder="请选择单位"  clearable>
            <el-option
              v-for="item in mtrlTypeGroupOpt"
              :key="item.id"
              :label="item.param1"
              :value="item.param1">
            </el-option>
          </el-select> -->
          <el-input v-model="mtrlNuit" disabled maxlength="30" placeholder="暂无物料单位" show-word-limit></el-input>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column label="用量">
      <template slot="header">
        <span class="vg_deep_red">用量</span>
      </template>
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.smpl_mtrl_consume'" :rules="[{ required: true }]" label-width="0">
          <el-input
            v-model="smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_consume"
            maxlength="9"
            placeholder="暂无用量"
            show-word-limit
            @blur="
              smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_consume = helper.calcPrice(
                smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_consume,
                4,
                10000
              )
            "
            @change="totalPriceChange(scope.$index)"
            @input="
              smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_consume = helper.keepTNum1(
                smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_consume
              )
            "
          ></el-input>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column label="单价">
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.mtrl_prod_price'" label-width="0">
          <el-input
            v-model="smplForm.smpl_plmtrl_list[scope.$index].mtrl_prod_price"
            maxlength="11"
            placeholder="暂无单价"
            show-word-limit
            @change="priceChange(scope)"
            @input="
              smplForm.smpl_plmtrl_list[scope.$index].mtrl_prod_price = helper.keepTNum1(
                smplForm.smpl_plmtrl_list[scope.$index].mtrl_prod_price
              )
            "
          ></el-input>
        </el-form-item>
      </template>
    </el-table-column>
    <!-- <el-table-column label="损耗比率">
      <template v-slot="scope">
        <el-form-item label-width="0" :prop="'smpl_plmtrl_list.'+scope.$index+'.smpl_mtrl_loss'">
          <el-input @change="lossChange(smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_loss,scope.$index)" @input="smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_loss =helper.keepTNum1(smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_loss )
                " v-model="smplForm.smpl_plmtrl_list[scope.$index].smpl_mtrl_loss" maxlength="30" show-word-limit placeholder="暂无损耗比率"></el-input>
        </el-form-item>
      </template>
    </el-table-column> -->
    <el-table-column label="工艺费用" width="200">
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.smpl_comp_addcost'" label-width="0">
          <el-row>
            <el-col :md="8"><span>复合费用</span></el-col>
            <el-col :md="16">
              <el-input
                v-model="smplForm.smpl_plmtrl_list[scope.$index].smpl_comp_addcost"
                :disabled="smplForm.smpl_plmtrl_list[scope.$index].compFlag"
                maxlength="7"
                placeholder="暂无复合费用"
                show-word-limit
                @change="priceChange1(scope)"
                @input="
                  smplForm.smpl_plmtrl_list[scope.$index].smpl_comp_addcost = helper.keepTNum1(
                    smplForm.smpl_plmtrl_list[scope.$index].smpl_comp_addcost
                  )
                "
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.smpl_prit_addcost'" label-width="0">
          <el-row>
            <el-col :md="8"><span>印花费用</span></el-col>
            <el-col :md="16">
              <el-input
                v-model="smplForm.smpl_plmtrl_list[scope.$index].smpl_prit_addcost"
                :disabled="smplForm.smpl_plmtrl_list[scope.$index].pritFlag"
                maxlength="7"
                placeholder="暂无印花费用"
                show-word-limit
                @change="priceChange2(scope)"
                @input="
                  smplForm.smpl_plmtrl_list[scope.$index].smpl_prit_addcost = helper.keepTNum1(
                    smplForm.smpl_plmtrl_list[scope.$index].smpl_prit_addcost
                  )
                "
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column label="金额" show-overflow-tooltip>
      <template v-slot="scope">
        <el-form-item :prop="'smpl_plmtrl_list.' + scope.$index + '.totalChange'" label-width="0">
          <el-input
            v-model="smplForm.smpl_plmtrl_list[scope.$index].totalChange"
            disabled
            maxlength="9"
            placeholder="暂无金额"
            show-word-limit
          ></el-input>
        </el-form-item>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { get } from '@api/request';
import { mtrlAPI } from '@api/modules/mtrl';
import SubTable from '@/views/DevelopManagement/SmplManage/TabChild/Componet/TabPanel/subTable/subTable.vue';

export default {
  name: 'SmplEditPrcsChild',
  components: { SubTable },
  props: {
    smplForm: {
      type: Object,
      required: true
    },
    mtrlTypeGroupOpt: {
      type: Array,
      required: true
    },
    plmtrlShow: {
      type: Boolean,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selectPlmtrlOption: [],
      selectionsList: [],
      flag: true,
      compList: ['复合', '印花', '电绣'],
      show: false,
      mtrlNuit: '米',
      multipleModel: null,
      lastQuery: ''
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {},
    compListChange(val, num) {
      this.$emit('compListChange', val, num);
    },
    // 删除
    handleClose(scope, val) {
      if (!this.isShow) {
        this.$emit('deletePlmtrl', scope, val);
      }
    },
    changePlmtrlOption(val, index) {
      this.selectPlmtrlOption = this.smplForm.smpl_plmtrl_list[index].plmtrlOption.filter(x => x.mtrl_type === val);
    },
    // 计算总金额
    totalPriceChange(scope) {
      this.$emit('priceChange', scope);
    },
    addDefaultList(index) {
      this.selectPlmtrlOption = [];
      this.selectPlmtrlOption = Array.from(
        this.smplForm.smpl_mtrl_list,
        ({ mtrl_name, mtrl_no, mtrl_prod_price, mtrl_spec, mtrl_type, smpl_mtrl_id }) => ({
          mtrl_name: mtrl_name,
          mtrl_no: mtrl_no,
          mtrl_prod_price: mtrl_prod_price,
          mtrl_spec: mtrl_spec,
          mtrl_type: mtrl_type,
          smpl_mtrl_id: smpl_mtrl_id
        })
      ).filter(({ mtrl_type }) => mtrl_type === this.smplForm.smpl_plmtrl_list[index].smpl_mtrl_type);
    },
    // 下拉框回显
    plmtrlChange(scope) {
      if (!this.isShow) {
        this.flag = false;
        this.multipleModel.forEach(async item => {
          await this.$emit('plmtrlChangeIds', scope, item);
        });
        this.$nextTick(() => {
          this.flag = true;
        });
      }
    },
    // 选择框输入值改变裁片选择
    plmtrlChangeCut(scope) {
      let temp = 0;
      get(mtrlAPI.judgeMtrlNo, { mtrl_no: scope.row.mtrl_no })
        .then(res => {
          if (res.data.code === 0) {
            for (let i = 0; i < this.smplForm.smpl_plmtrl_list.length; i++) {
              if (this.smplForm.smpl_plmtrl_list[i].mtrl_no === scope.row.mtrl_no) {
                temp += 1;
              }
            }
            if (temp > 1) {
              scope.row.mtrl_no = null;
              this.$message.error('物料编号重复，请重新填写！');
            } else {
              this.$emit('plmtrlChangeCut', scope);
            }
          } else {
            scope.row.mtrl_no = null;
            this.$message.error('物料编号重复，请重新填写！');
            this.$emit('plmtrlShowChange');
          }
        })
        .catch(() => {});
    },
    priceChange(scope) {
      scope.row.mtrl_prod_price = this.helper.calcPrice(scope.row.mtrl_prod_price, 4, 1000000);
      this.totalPriceChange(scope.$index);
    },
    priceChange1(scope) {
      if (this.smplForm.smpl_plmtrl_list[scope.$index].smpl_comp_addcost) {
        scope.row.smpl_comp_addcost = this.helper.calcPrice(scope.row.smpl_comp_addcost, 2, 100);
      } else {
        scope.row.smpl_comp_addcost = '0.0000';
      }
      this.totalPriceChange(scope.$index);
    },
    priceChange2(scope) {
      if (this.smplForm.smpl_plmtrl_list[scope.$index].smpl_prit_addcost) {
        scope.row.smpl_prit_addcost = this.helper.calcPrice(scope.row.smpl_prit_addcost, 2, 100);
      } else {
        scope.row.smpl_prit_addcost = '0.0000';
      }
      this.totalPriceChange(scope.$index);
    },
    //prcs清单选择框
    handleSelectionChange2(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
      this.$emit('handleSelectionChange2', this.selectionsList);
    },
    onChange() {
      const select = this.$refs.multiSelect;
      if (select) {
        // 防止 Element 清空 query
        this.$nextTick(() => {
          select.visible = true; // 阻止下拉自动收起
        });
      }
    }
  }
};
</script>

<style lang="scss">
.vd_dis {
  display: inline-block;
}
.vd_mrl {
  margin-left: 5px;
}
.vd_wid100 {
  width: 100%;
}
.vd_font20 {
  margin-top: 5px;
  font-size: 20px;
}
.vd_clire {
  background-color: #c4bcbc;
  border-radius: 50%;
  padding: 2px !important;
  border: 0;
  color: #fff;
}
.vd_dis {
  width: 100%;
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
}
.vd_magr3 {
  margin-right: 3px;
}
.vd_dis_flex {
  display: flex;
}
</style>
